export const analyticsConfig = {
    measurementId: 'G-T3FFZ4XSGM',
    uploadStageTraffic: true,
};



// WEBPACK FOOTER //
// ./node_modules/tslint-loader??ref--1!./src/services/analytics/config.ts